<template>
  <div
        class="modal trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" >CONFIRM</h5>
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <!-- Chart -->
              <div class="chart">
                <img src="@/assets/img/vector/upload-csv01.png" class="w-25 img-fluid" alt="Import" />
                <h4>
                  <i class="fas fa-info-circle"></i> INFORMATION
                </h4>
                <p v-if="Object.entries(data.processMap).filter(([key, details]) => details.fixed).length" class="modalp">Contents of the imported {{type}} file:</p>
                 <ul class="text-left">
                    <li v-for="([key , details])  in  Object.entries(data.processMap).filter(([key, details]) => details.fixed)" :key="key">
                     {{ key }} ({{ details.count }} Lines)
                    </li>
                 </ul>
                 <p v-if="Object.entries(data.processMap).filter(([key, details]) => !details.fixed).length" class="modalp">Previous imported data is present for other accounts,please select {{type}}-data you wish to override (optional):</p>
                 <ul class="text-left">
                    <li v-for="([key , details])  in  Object.entries(data.processMap).filter(([key, details]) => !details.fixed)" :key="key">
                     <input type="checkbox" v-model="details.accountMap" /> {{ key }}
                    </li>
                 </ul>
              </div>
              <div class="modal-footer bid">
                    <button type="button" class="btn btn-secondary"  @click="$emit('close')">Close</button>
                    <button type="button" class="btn btn-primary" @click="updatePositions()">CONTINUE</button>
                </div>
            </div>

            <!-- {{ data.processMap }} -->
          </div>
        </div>
  </div>
</template>
<script>
    import authService from "@/authService";
    import config from "@/config";
    // import config from "@/config";
// import { data } from "jquery";
    export default {
        name: 'inventoryImportmodal',
        components :{
            
        },
        props :["data","filePath","url","type"],
        data() {
            return {
                loading : false,
                error : null,
                errors: [],
                success : false,
                uploadPercentage: 0,
                lastUploadedDate : null
                
            };
        },
        methods: {
            updatePositions(){
            this.loading = true;
            const auth = {
                headers: { 'org-token' : authService.getOrgToken() }
            };
            let dataToSend  =  {
            //   "userId" : authService.getUser().id,
              "key": this.filePath,
              "cognitoSub" : authService.getUser().cognitoSub,
              "accountUpdateMap": Object.fromEntries(
                        Object.entries(this.data.processMap).map(([account, details]) => [
                        account,
                        details.fixed ? details.fixed : (details.accountMap !== undefined ? details.accountMap : false),
                        ])
                    )
            }
            console.log(dataToSend)
            this.$http
            .post(
              config.baseUrlAutoBidder + this.url,
                dataToSend,
               auth
            )
            .then(() => {
              this.loading = false;
              this.$emit('close')
            })
            .catch(e => {
                console.log("Error", e);
                this.loading = false;
              });
          },
      
        },
        mounted() {
            console.log(this.data)
        }
    };
    </script>